import React from 'react';
import { motion } from 'framer-motion';

const LineagesHeroRo = () => (
  <section 
    className="relative min-h-[60vh] flex items-center pt-28 pb-16 overflow-hidden bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url('https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2Uvd2VicA==/1f63737aa15550d672883c3a151a8db5.webp')` }}
  >
    <div className="absolute inset-0 z-0 bg-black/60"></div>
    <div className="absolute inset-0 z-0 bg-gradient-to-b from-brand-dark/90 via-transparent to-brand-dark"></div>
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-accent/10 blur-[150px] rounded-full z-0"></div>

    <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10 text-center">
      <motion.p 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        className="text-brand-accent font-semibold tracking-widest uppercase text-sm mb-4 drop-shadow-md"
      >
        Sci-Fi Multi-Generațional · Dinastii de Personaje
      </motion.p>
      <motion.h1 
        initial={{ opacity: 0, y: 30 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ delay: 0.1 }} 
        className="text-4xl md:text-6xl font-display font-bold text-white mb-6 text-glow"
      >
        Liniile Familiale
      </motion.h1>
      <motion.p 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ delay: 0.2 }} 
        className="text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed drop-shadow-md"
      >
        Patru Familii. Cinci Secole. O Cronică.
      </motion.p>
    </div>
  </section>
);

export default LineagesHeroRo;